import { getPatternStyles, patternFns, __spreadValues } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const centerConfig = {
transform(props) {
  return __spreadValues({
    display: "grid",
    placeItems: "center",
    width: "100%",
    height: "100%"
  }, props);
}}

export const getCenterStyle = (styles = {}) => {
  const _styles = getPatternStyles(centerConfig, styles)
  return centerConfig.transform(_styles, patternFns)
}

export const center = (styles) => css(getCenterStyle(styles))
center.raw = getCenterStyle